import { call, put, select } from 'typed-redux-saga';

import { SELF } from '../../../../../shared/constants';
import { goloomSdk } from '../../../../../shared/features/goloom-sdk';
import { getUserSelector } from '../../../../../shared/features/user';
import { i18n } from '../../../../../shared/helpers/i18n';
import { cloudApi } from '../../../../../shared/helpers/transport';
import { getParticipantById } from '../../../selectors';
import { ParticipantState } from '../../../types';
import { updateParticipant } from '../slice';

export function* changeUserSaga() {
    const user = yield* select(getUserSelector);
    const displayName = user?.name || i18n('common', 'guest');

    yield call([goloomSdk, goloomSdk.setName], displayName);

    yield* put(
        updateParticipant({
            id: SELF,
            displayName,
        })
    );
}

/**
 * Стягивает информацию о пользователе
 *
 */
export function* fetchMeSaga() {
    const participant = yield* select(getParticipantById, SELF);
    let result: Partial<ParticipantState> | undefined;

    if (participant?.avatarUrl && participant.displayName) {
        // если в стейте есть юзер, то его и возвращаем
        return participant;
    }

    const user = yield* select(getUserSelector);

    if (user?.uid) {
        const me = yield* call([cloudApi, cloudApi.getMeUser]); // если его нет, то фетчим

        if (me) {
            const updateData: Partial<ParticipantState> = {
                avatarUrl: me.avatar_url as string | undefined,
                isDefaultAvatar: me.is_default_avatar as boolean | undefined,
                displayName: me.display_name as string | undefined,
                avatarPlaceholder: me.avatar_placeholder
                    ? {
                          abbreviation: me.avatar_placeholder.abbreviation,
                          backgroundColor: me.avatar_placeholder.background_color,
                          textColor: me.avatar_placeholder.text_color,
                      }
                    : undefined,
            };

            yield* put(
                updateParticipant({
                    id: SELF,
                    ...updateData,
                })
            );

            result = updateData;
        }
    } else {
        result = {
            displayName: i18n('common', 'guest'),
        };
    }

    return result;
}
